import { getDeltaRecordFields } from "@/pages/models/release/Technical/MappingV2/deltaMappingAutocomplete";
import type { ReleaseWithAdapterCollections } from "./types";

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value);

/**
 * The fields a delta mapping's `record` has, as the mapping editor offers them: the derived table's columns or the
 * entity's attributes. Undefined when unknown, so `recordField` checks accept any reference.
 */
export const getMappingRecordFields = (
  release: ReleaseWithAdapterCollections,
  values: unknown,
): string[] | undefined => {
  if (!isRecord(values)) return undefined;
  if (values.sourceType === "derivedTable") {
    return release.derivedTables?.find((table) => table.id === values.derivedTableId)?.cols.map((column) => column.n);
  }
  if (typeof values.entity !== "string" || !values.entity || !release.rule_graph) return undefined;
  return getDeltaRecordFields(
    release.rule_graph,
    values.entity,
    isRecord(values.childExpansion) ? values.childExpansion : undefined,
  );
};
